// SearchInput — Input de búsqueda con ícono de lupa. Envuelve el Input del kit (que no tiene slot
// de ícono). Controlado por value / onChange(value) — más cómodo que exponer el evento al caller.
// Reproduce el "[Buscar...]" de las barras de lista de los mocks M6.
import { Search } from 'lucide-react';
import { cn } from '@/lib/cn';
import { Input } from '@/kit';

export interface SearchInputProps {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    ariaLabel?: string;
    className?: string;
}

export function SearchInput({
    value,
    onChange,
    placeholder = 'Buscar…',
    ariaLabel,
    className,
}: SearchInputProps) {
    return (
        <div className={cn('relative', className)}>
            <Search
                className="pointer-events-none absolute left-2.5 top-1/2 size-4 -translate-y-1/2 text-muted-foreground"
                aria-hidden
            />
            <Input
                type="search"
                value={value}
                onChange={(e) => {
                    onChange(e.target.value);
                }}
                placeholder={placeholder}
                aria-label={ariaLabel ?? placeholder}
                className="pl-8"
            />
        </div>
    );
}
